import { useCallback } from 'react';

import { getEnvVars } from '@order/utils';

import { loadStripeWithRetry, StripeLogger } from '../../utils';
import { withRadarSessionTimeout } from './helpers';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Creates a Stripe Radar Session on web and returns its id.
 * Resolves to `undefined` on error or timeout so callers can fall back.
 */
export const useCreateRadarSession = () => {
  return useCallback(async () => {
    try {
      const stripe = await loadStripeWithRetry(STRIPE_PUBLIC_KEY);

      if (!stripe) return;

      const { radarSession, error } = await withRadarSessionTimeout(stripe.createRadarSession());

      if (error) StripeLogger.logRadarSessionError(error);

      const id = radarSession?.id;

      return typeof id === 'string' ? id : undefined;
    } catch (error) {
      StripeLogger.logRadarSessionError(error as Error);

      return;
    }
  }, []);
};

// ─── Constants ───────────────────────────────────────────────────────────────

const STRIPE_PUBLIC_KEY = getEnvVars().STRIPE_PUBLIC_KEY;
